import logo from './logo.svg';
import './App.css';
import Hero from './components/Hero';
import Moment from './components/Moment';
import Actor from './components/Actor';
import Destination from './components/Destination';
import Contact from './components/Contact';
import Header from './components/Header';

function App() {
  return (
     <>
     <Header />
     <Hero />
     <Moment />
     <Actor />
     <Destination /> 
     <Contact />
     </>
  );
}

export default App;
